import { PROJECT_CONFIG } from '../config/project-info';

export class FooterComponent {
  public render(): string {
    const year = new Date().getFullYear();

    return `
      <footer class="border-t border-terminal-border py-12 bg-terminal-bgDark font-mono text-xs text-terminal-muted">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 text-center">
          
          <div class="flex flex-wrap items-center justify-center gap-6">
            <a href="#" class="text-matrix-400 hover:text-matrix-300 transition-colors">Home</a>
            <a href="#features" class="hover:text-terminal-fg transition-colors">Features</a>
            <a href="#gallery" class="hover:text-terminal-fg transition-colors">Screenshots</a>
            <a href="#shortcuts" class="hover:text-terminal-fg transition-colors">Shortcuts</a>
            <a href="#install" class="hover:text-terminal-fg transition-colors">Install</a>
            <a href="#/news" class="text-amber-400 hover:text-amber-300 transition-colors">News</a>
            <a href="/feed.xml" target="_blank" class="text-amber-500 hover:text-amber-400 transition-colors">RSS</a>
            <a href="#/docs" class="text-matrix-400 hover:text-matrix-300 transition-colors">Documentation</a>
            <a href="#/community" class="text-cyber-400 hover:text-cyber-300 transition-colors">Community</a>
            <a href="${PROJECT_CONFIG.githubUrl}" target="_blank" rel="noopener noreferrer" class="hover:text-terminal-fg transition-colors">GitHub</a>
            <a href="${PROJECT_CONFIG.mastodonUrl}" target="_blank" rel="me noopener noreferrer" class="text-cyber-400 hover:text-cyber-300 transition-colors">@Mastui</a>
          </div>

          <div class="space-y-2 pt-2 border-t border-terminal-border/40">
            <p>
              © ${year} <strong>Mastui</strong> — Built with passion by <a href="${PROJECT_CONFIG.maintainerUrl}" target="_blank" rel="noopener noreferrer" class="text-matrix-400 hover:underline font-semibold">${PROJECT_CONFIG.maintainerName}</a>.
            </p>
            <p class="text-[11px] text-terminal-muted/80">
              Released under the <a href="${PROJECT_CONFIG.licenseUrl}" target="_blank" rel="noopener noreferrer" class="text-matrix-500 hover:underline">MIT License</a>. Powered by Python & Textual.
            </p>
          </div>

        </div>
      </footer>
    `;
  }
}
